var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledFrontEndAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 15.5C19 14.6875 19.6562 14 20.5 14H21.5C22.3125 14 23 14.6875 23 15.5V26.5C23 27.3438 22.3125 28 21.5 28H20.5C19.6562 28 19 27.3438 19 26.5V15.5ZM14 21.5C14 20.6875 14.6562 20 15.5 20H16.5C17.3125 20 18 20.6875 18 21.5V26.5C18 27.3438 17.3125 28 16.5 28H15.5C14.6562 28 14 27.3438 14 26.5V21.5ZM26.5 16C27.3125 16 28 16.6875 28 17.5V26.5C28 27.3438 27.3125 28 26.5 28H25.5C24.6562 28 24 27.3438 24 26.5V17.5C24 16.6875 24.6562 16 25.5 16H26.5Z",
    fill: "#5F6774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledFrontEndAnalytics);
export default __webpack_public_path__ + "static/media/filledFrontEndAnalytics.26197d2a4bef234d8e110a53151cecc7.svg";
export { ForwardRef as ReactComponent };